package at.theatervogelweide.admin.contract.imprint

import at.theatervogelweide.admin.contract.AdminResult
import at.theatervogelweide.admin.contract.VersionedId
import kotlinx.rpc.annotations.Rpc

/** Impressum (#84, #147): every admin reads it, only superusers save it, also through MCP. */
@Rpc
interface ImprintService {
    suspend fun load(): AdminResult<Imprint>

    /** Answers with `forbidden` unless the signed-in account is a superuser, `conflict` for a stale [imprint] version. */
    suspend fun save(imprint: VersionedId, draft: ImprintDraft): AdminResult<Imprint>
}
